import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.css'
})
export class LogoutComponent implements OnInit {
  isSSO: boolean = true;
  loaded: boolean = false;
  state: string = "logout";
  constructor(private router: Router, private authService: AuthService, private msalService: MsalService) {

  }


  ngOnInit(): void {
    this.state = this.authService.getAuthState() ? this.authService.getAuthState()! : "logout";
    if (this.authService.getToken()) {
      this.isSSO = this.authService.getCustomer().length > 0;
      this.authService.removeToken();
      this.authService.removeCustomer();

      if (this.isSSO) {
        this.loaded = true;
      } else {
        this.msalService.instance.clearCache();
        this.msalService.instance.setActiveAccount(null);
        Object.keys(localStorage)
          .filter(k => k.startsWith('msal.'))
          .forEach(k => localStorage.removeItem(k));
        this.router.navigate(['/']);
      }
    } else {
      this.loaded = true;
      this.isSSO = false;
    }
  }

  redirectNow(): void {
    this.authService.login();
  }
}
